/**
 * App Download Web Component
 * This component detects the user's OS and provides the appropriate download link for the app. It also includes a fallback for unsupported platforms.
 */

class AppDownload extends HTMLElement {
    #shadow;

    constructor() {  
        super();
        this.#shadow = this.attachShadow({ mode: 'open' });
        this.#shadow.innerHTML = this.#template();
    }

    connectedCallback() {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const platform = navigator.platform || '';
        const isIPadOS  = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
        const isIOS     = (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) || isIPadOS;
        const isAndroid = /android/i.test(ua);
        const isMac     = /mac/i.test(platform);
        const isWindows = /win/i.test(platform);
        const isLinux   = /linux/i.test(platform);

        const links = this.#shadow.querySelector('.app-download-links');
        if (!links) return;

        const appleStore = links.querySelector('.apple-store');
        const googlePlay = links.querySelector('.google-play');

        if (!appleStore || !googlePlay) return;

        // Reset visibility before applying the OS-specific rule.
        appleStore.style.display = '';
        googlePlay.style.display = '';

        if (isIOS) {
            googlePlay.style.display = 'none';
        } else if (isAndroid) {
            appleStore.style.display = 'none';
        } else if (isMac) {
            // Desktop macOS users should get the App Store badge.
            googlePlay.style.display = 'none';
        } else if (isWindows || isLinux) {
            // Desktop non-Apple users should get the Google Play badge.
            appleStore.style.display = 'none';
        }
    }

    //Create the template for the component
    #template() {
        return `
            <style>
                /* Styles for the shadow ROOT of the component to allow for customization from the outside of the web component */
                :host {
                    --app-download-gap: 20px;
                    --app-download-margin-top: 20px;
                    --app-download-border: 1px solid #cbd5e1;
                }
                .app-download-links {
                    display: flex;
                    gap: 20px;
                    margin-top: 20px;
                    margin-bottom: 20px;            
                }
                .app-download-links img {
                    max-width: 130px;
                }
                @media (min-width: 992px) {
                    .d-lg-none {
                        display: none;
                    }
                }
            </style>
            <div class="app-download-links d-lg-none">
                <a href="#" class="apple-store">
                    <img src="../assets/images/badge-apple-store.webp" alt="Download on the Apple Store">
                </a>
                <a href="#" class="google-play">
                    <img src="../assets/images/badge-google-play.webp" alt="Download on the Google Play Store">
                </a>
            </div>
        `;
    }
}

if (!customElements.get('app-download')) {
    customElements.define('app-download', AppDownload);
}